import { useSelector } from "react-redux";
import { useManagerPaymentQuery } from "queries/Sales/useManagerPaymentQuery";
import { getToday } from "utils/date";

/**
 * 홈 "오늘의 매출" 카드용. 매출 탭과 같은 집계 API를 오늘 하루 기준으로 조회한다.
 * 매출 탭 상태(searchDate/searchPeriodType)에 따르지 않는다.
 */
export const useTodayPaymentQuery = () => {
  const { seqPartner, seqPartnerBranch } = useSelector((s: any) => s.partner);

  return useManagerPaymentQuery({
    seqPartner,
    periodType: "daily",
    referenceDate: getToday(),
    periodCount: 1,
    seqPartnerBranches: seqPartnerBranch ? [seqPartnerBranch] : undefined,
  });
};
